import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-plus-circle-fill",
  "use": "rt-portal-plus-circle-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-plus-circle-fill\">\r\n<path d=\"M512,64C264.6,64,64,264.6,64,512s200.6,448,448,448s448-200.6,448-448S759.4,64,512,64z M692,536c0,8.8-7.2,16-16,16H552\r\n\tv124c0,8.8-7.2,16-16,16h-48c-8.8,0-16-7.2-16-16V552H348c-8.8,0-16-7.2-16-16v-48c0-8.8,7.2-16,16-16h124V348c0-8.8,7.2-16,16-16\r\n\th48c8.8,0,16,7.2,16,16v124h124c8.8,0,16,7.2,16,16V536z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/plus-circle-fill.svg
// module id = 1261
// module chunks = 101